import { FunctionComponent, memo } from 'react';
import cn from 'classnames'
import { TreeProps } from './tree.interface'
import { TreeItem } from './tree.item'
import './tree.style.scss'

const TreeComponent = (props: TreeProps) => {
  const { items, className, ...restProps } = props
  const classNames = cn('legion-tree', className)

  return (
    <div {...restProps} className={classNames}>
      {items?.map((item, index) => <TreeItem key={index} items={item}/>)}
    </div>
  )
}

export const Tree = memo(TreeComponent as FunctionComponent<TreeProps>)
